import React from 'react';
import {observer} from 'mobx-react';
import {observable, action} from 'mobx';
import {injectIntl} from 'react-intl';
import PropTypes from 'prop-types';


@injectIntl @observer
export default class ButtonWithImage extends React.Component {
    constructor(props) {
        super(props);


        this.state = {};
    }

    render() {
        const {label, image, onClick, ...rest} = this.props;

        return (
            <div className="button-with-image-container" {...rest} onClick={onClick}>
                <div>
                    <img src={image} className="hide-select-background"></img>
                </div>

                <div style={{textAlign: 'center'}}>
                    {label}
                </div>
            </div>
        );
    }
}

ButtonWithImage.propTypes = {
    label: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};